<template>
  <div class="profile-page">
    <div class="profile-container">
      <!-- Profile Header -->
      <div class="profile-header">
        <div class="profile-header-content">
          <div class="profile-avatar-section">
            <div class="profile-avatar">
              <span class="avatar-initials">{{ userInitials }}</span>
            </div>
            <div class="profile-user-info">
              <h1 class="profile-name">
                {{ form.names }} {{ form.lastNames }}
              </h1>
              <p class="profile-id">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="12"
                    cy="7"
                    r="4"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ country == 0 ? "DNI" : "RUT" }}: {{ form.rut }}
              </p>
            </div>
          </div>
          <div class="profile-stats">
            <div class="profile-stat-item">
              <div class="stat-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                  <path
                    d="M9 12L11 14L15 10"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span class="stat-label">Perfil Verificado</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Profile Form -->
      <b-form
        @submit="onSubmit"
        @reset="onReset"
        v-if="show"
        class="profile-form"
      >
        <!-- Personal Information Section -->
        <div class="profile-section">
          <div class="section-header-card">
            <div class="section-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <circle
                  cx="12"
                  cy="7"
                  r="4"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="section-header-text">
              <h3>Información Personal</h3>
              <p>Datos básicos de tu perfil</p>
            </div>
          </div>

          <div class="section-content">
            <b-row>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="7"
                        r="4"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Nombres
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.names"
                    :readonly="true"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="7"
                        r="4"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Apellidos
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.lastNames"
                    :readonly="true"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="16"
                        rx="2"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M7 8H17M7 12H12"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                    {{ country == 0 ? "DNI" : "RUT" }}
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.rut"
                    :readonly="true"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12" v-if="form.razonSocial">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 21H21M5 21V7L12 3L19 7V21M9 21V15H15V21"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Razón Social
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.razonSocial"
                    :readonly="true"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M16 2V6M8 2V6M3 10H21"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                    Fecha de Nacimiento
                  </label>
                  <b-form-datepicker
                    class="custom-input custom-datepicker"
                    v-model="form.bornDate"
                    locale="es-ES"
                    label-no-date-selected="Seleccionar fecha"
                  ></b-form-datepicker>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M12 8V12L15 15"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                    Sexo
                  </label>
                  <b-form-select
                    class="custom-input custom-select"
                    v-model="form.gender"
                    :options="genders"
                  >
                    <template #first>
                      <b-form-select-option :value="null" disabled
                        >Seleccionar sexo</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <circle
                        cx="12"
                        cy="10"
                        r="3"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Nacionalidad
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.nationality"
                    :readonly="true"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 2L2 7L12 12L22 7L12 2Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 17L12 22L22 17"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 12L12 17L22 12"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Profesión
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.profession"
                    :readonly="true"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- Contact Information Section -->
        <div class="profile-section">
          <div class="section-header-card">
            <div class="section-icon contact-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path
                  d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7294C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1469 21.5901 20.9046 21.7335 20.6408 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77383 17.3147 6.72534 15.2662 5.19 12.85C3.49998 10.2412 2.44824 7.27099 2.12 4.18C2.09501 3.90347 2.12788 3.62476 2.2165 3.36162C2.30513 3.09849 2.44757 2.85669 2.63477 2.65162C2.82196 2.44655 3.04981 2.28271 3.30379 2.17052C3.55778 2.05833 3.83234 2.00026 4.11 2H7.11C7.59531 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04208 3.23945 9.11 3.72C9.23662 4.68007 9.47145 5.62273 9.81 6.53C9.94455 6.88792 9.97366 7.27691 9.89391 7.65088C9.81415 8.02485 9.62886 8.36811 9.36 8.64L8.09 9.91C9.51356 12.4136 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9752 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="section-header-text">
              <h3>Información de Contacto</h3>
              <p>Teléfonos y medios de comunicación</p>
            </div>
          </div>

          <div class="section-content">
            <b-row>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7294C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1469 21.5901 20.9046 21.7335 20.6408 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77383 17.3147 6.72534 15.2662 5.19 12.85C3.49998 10.2412 2.44824 7.27099 2.12 4.18C2.09501 3.90347 2.12788 3.62476 2.2165 3.36162C2.30513 3.09849 2.44757 2.85669 2.63477 2.65162C2.82196 2.44655 3.04981 2.28271 3.30379 2.17052C3.55778 2.05833 3.83234 2.00026 4.11 2H7.11C7.59531 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04208 3.23945 9.11 3.72C9.23662 4.68007 9.47145 5.62273 9.81 6.53C9.94455 6.88792 9.97366 7.27691 9.89391 7.65088C9.81415 8.02485 9.62886 8.36811 9.36 8.64L8.09 9.91C9.51356 12.4136 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9752 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Teléfono Fijo
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.telephone"
                    :readonly="true"
                    placeholder="No registrado"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="5"
                        y="2"
                        width="14"
                        height="20"
                        rx="3"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M12 18H12.01"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                    Teléfono Móvil
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.phone"
                    :readonly="true"
                    placeholder="No registrado"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- Marital Status Section -->
        <div class="profile-section">
          <div class="section-header-card">
            <div class="section-icon marital-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.1283 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22249 22.4518 8.5C22.4518 7.77751 22.3095 7.0621 22.0329 6.39464C21.7563 5.72718 21.351 5.12075 20.84 4.61Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="section-header-text">
              <h3>Estado Civil</h3>
              <p>Información matrimonial y patrimonial</p>
            </div>
          </div>

          <div class="section-content">
            <b-row>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M12 6V12L16 14"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                    Estado Civil
                  </label>
                  <b-form-select
                    class="custom-input custom-select"
                    v-model="form.estadoCivil"
                    :options="estadosCiviles"
                  ></b-form-select>
                </div>
              </b-col>
              <b-col
                lg="6"
                md="6"
                cols="12"
                v-if="form.estadoCivil == 'Casado(a)'"
              >
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 21H21M5 21V7L12 3L19 7V21M9 21V15H15V21"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Régimen Patrimonial
                  </label>
                  <b-form-select
                    class="custom-input custom-select"
                    v-model="form.regimenPatrimonial"
                    :options="regimenPatriomonialOpciones"
                  ></b-form-select>
                </div>
              </b-col>
              <b-col
                lg="6"
                md="6"
                cols="12"
                v-if="form.estadoCivil == 'Casado(a)'"
              >
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="7"
                        r="4"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Nombres del Cónyuge
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.spouseNames"
                    :readonly="true"
                    placeholder="No registrado"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col
                lg="6"
                md="6"
                cols="12"
                v-if="form.estadoCivil == 'Casado(a)'"
              >
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="7"
                        r="4"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                    </svg>
                    Apellidos del Cónyuge
                  </label>
                  <b-form-input
                    class="custom-input readonly-field"
                    v-model="form.spouseLastNames"
                    :readonly="true"
                    placeholder="No registrado"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- Security Section -->
        <div class="profile-section security-section">
          <div class="section-header-card">
            <div class="section-icon security-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect
                  x="3"
                  y="11"
                  width="18"
                  height="11"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <circle cx="12" cy="16" r="1" fill="currentColor" />
              </svg>
            </div>
            <div class="section-header-text">
              <h3>Seguridad</h3>
              <p>Cambia tu contraseña de acceso</p>
            </div>
          </div>

          <div class="security-notice">
            <div class="notice-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M12 8V12M12 16H12.01"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <p>
              Solo completa estos campos si deseas cambiar tu contraseña actual.
            </p>
          </div>

          <div class="section-content">
            <b-row>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="11"
                        width="18"
                        height="11"
                        rx="2"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                    Nueva Contraseña
                  </label>
                  <b-form-input
                    id="change-password-input"
                    ref="changePasswordInput"
                    class="custom-input"
                    v-model="form.password"
                    type="password"
                    :state="validLengh"
                    placeholder="Mínimo 6 caracteres"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    La contraseña debe tener al menos 6 caracteres
                  </b-form-invalid-feedback>
                </div>
              </b-col>
              <b-col lg="6" md="6" cols="12">
                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="M9 12L11 14L15 10"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Confirmar Contraseña
                  </label>
                  <b-form-input
                    class="custom-input"
                    v-model="form.passwordConfirmation"
                    type="password"
                    :state="validPassword"
                    placeholder="Repite tu contraseña"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Las contraseñas deben coincidir
                  </b-form-invalid-feedback>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="profile-actions">
          <button type="submit" class="btn-save-profile">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16L21 8V19C21 20.1046 20.1046 21 19 21Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17 21V13H7V21M7 3V8H15"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Guardar Cambios
          </button>
        </div>
      </b-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "information",
  data() {
    return {
      form: {
        names: "",
        lastNames: "",
        rut: "",
        razonSocial: "",
        bornDate: "",
        gender: null,
        telephone: "",
        phone: "",
        profession: "",
        estadoCivil: "Soltero(a)",
        regimenPatrimonial: "Ganancial",
        nationality: "",
        spouseNames: "",
        spouseLastNames: "",
        password: "",
        passwordConfirmation: "",
      },
      genders: ["MASCULINO", "FEMENINO", "NO BINARIE"],
      estadosCiviles: [
        "Soltero(a)",
        "Casado(a)",
        "Viudo(a)",
        "Divorciado(a).",
        "Conviviente civil.",
      ],
      regimenPatriomonialOpciones: [
        "Ganancial",
        "Separación de bienes",
        "Participación",
      ],
      show: true,
    };
  },
  beforeMount() {
    this.form.names = this.$auth.watch.data.name;
    this.form.lastNames = this.$auth.watch.data.lastname;
    this.form.rut = this.$auth.watch.data.rut;
    this.form.nationality = this.$auth.watch.data.nationality;
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToPasswordIfRequested();
    });
  },
  methods: {
    scrollToPasswordIfRequested() {
      if (this.$route?.query?.scrollTo !== "password") return;

      this.scheduleScrollToChangePasswordInput();
    },

    scheduleScrollToChangePasswordInput() {
      let attempts = 0;
      const maxAttempts = 10;

      const tick = () => {
        attempts += 1;
        const didScroll = this.scrollToChangePasswordInput();
        if (!didScroll && attempts < maxAttempts) {
          setTimeout(tick, 100);
        }
      };

      tick();
      requestAnimationFrame(tick);
      setTimeout(tick, 300);
    },

    findScrollableParent(element) {
      let current = element;
      while (current && current.parentElement) {
        current = current.parentElement;
        const style = window.getComputedStyle(current);
        const overflowY = style.overflowY;
        const canScroll =
          (overflowY === "auto" || overflowY === "scroll") &&
          current.scrollHeight > current.clientHeight;
        if (canScroll) return current;
      }
      return document.scrollingElement || document.documentElement;
    },

    scrollToChangePasswordInput() {
      const el = this.$refs.changePasswordInput;
      if (!el || !el.$el) return false;

      // En BootstrapVue, $el normalmente es el input real.
      const input = el.$el;
      if (!input || !input.getBoundingClientRect) return false;

      const scrollParent = this.findScrollableParent(input);
      const offset = 120;

      if (
        scrollParent === document.scrollingElement ||
        scrollParent === document.documentElement
      ) {
        const rect = input.getBoundingClientRect();
        const targetTop = rect.top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, targetTop), behavior: "smooth" });
      } else {
        const parentRect = scrollParent.getBoundingClientRect();
        const rect = input.getBoundingClientRect();
        const targetTop =
          rect.top - parentRect.top + scrollParent.scrollTop - offset;
        scrollParent.scrollTo({
          top: Math.max(0, targetTop),
          behavior: "smooth",
        });
      }

      try {
        input.focus({ preventScroll: true });
      } catch (e) {
        // ignore
      }

      return true;
    },
    getData() {
      this.axios
        .get("users/get")
        .then((result) => {
          this.form.estadoCivil = result.data.estadoCivil;
          this.form.telephone = result.data.telephone;
          this.form.phone = result.data.phone;
          this.form.nationality = result.data.nationality;
          this.form.profession = result.data.profession;
          this.form.bornDate = result.data.bornDate;
          this.form.spouseNames = result.data.spouseNames;
          this.form.spouseLastNames = result.data.spouseLastNames;
          this.form.regimenPatrimonial = result.data.regimenPatrimonial;
          this.form.gender = result.data.gender;
        })
        .finally(() => {
          this.$nextTick(() => {
            this.scrollToPasswordIfRequested();
          });
        });
    },
    onSubmit(event) {
      event.preventDefault();
      if (this.form.estadoCivil != "Casado(a)") {
        this.form.regimenPatrimonial = null;
        this.form.spouseNames = "";
        this.form.spouseLastNames = "";
      }
      this.axios
        .patch("users/edit", { user: this.form })
        .then(() => {
          this.$swal("Éxito", "usuario editado con éxito", "success");
        })
        .error(() => {
          this.$swal("Oops", "hubo un error editando", "error");
        });
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.names = "";
      this.form.lastNames = "";
      this.form.rut = "";
      this.form.razonSocial = "";
      this.form.bornDate = "";
      this.form.gender = null;
      this.form.telephone = "";
      this.form.phone = "";
      this.form.profession = "";
      this.form.estadoCivil = "Soltero/a";
      this.form.regimenPatrimonial = null;
      this.form.nationality = "";
      this.form.spouseNames = "";
      this.form.spouseLastNames = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  computed: {
    userInitials() {
      const names = this.form.names || "";
      const lastNames = this.form.lastNames || "";
      const firstInitial = names.charAt(0).toUpperCase();
      const lastInitial = lastNames.charAt(0).toUpperCase();
      return `${firstInitial}${lastInitial}`;
    },
    validPassword() {
      if (this.form.password.length == 0) return true;
      return this.form.password == this.form.passwordConfirmation &&
        this.form.passwordConfirmation.length >= 6
        ? true
        : false;
    },
    validLengh() {
      if (this.form.password.length == 0) return true;
      return this.form.password.length >= 6 ? true : false;
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 0;
    },
  },
};
</script>

<style scoped>
/* ==================== PROFILE PAGE STYLES ==================== */
.profile-page {
  background: transparent;
  min-height: 100vh;
}

.profile-container {
  max-width: 100%;
  margin: 0 auto;
}

/* ==================== PROFILE HEADER ==================== */
.profile-header {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  animation: headerFadeIn 0.5s ease;
}

@keyframes headerFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.profile-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.profile-avatar-section {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.profile-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.avatar-initials {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
}

.profile-user-info {
  color: #1f2937;
}

.profile-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
  color: #1f2937;
}

.profile-id {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #6b7280;
  margin: 0;
}

.profile-id svg {
  opacity: 0.8;
}

.profile-stats {
  display: flex;
  gap: 1rem;
}

.profile-stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #ffffff;
  border: 1px solid #d1fae5;
  padding: 0.5rem 0.875rem;
  border-radius: 8px;
  color: #10b981;
}

.stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #10b981;
}

.stat-label {
  font-size: 0.8125rem;
  font-weight: 500;
}

/* ==================== PROFILE SECTIONS ==================== */
.profile-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  animation: sectionFadeIn 0.4s ease backwards;
}

.profile-section:nth-child(1) {
  animation-delay: 0.1s;
}
.profile-section:nth-child(2) {
  animation-delay: 0.2s;
}
.profile-section:nth-child(3) {
  animation-delay: 0.3s;
}
.profile-section:nth-child(4) {
  animation-delay: 0.4s;
}

@keyframes sectionFadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-header-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.section-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: var(--color-btn, linear-gradient(90deg, #3b82f6, #2563eb));
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  flex-shrink: 0;
}

.section-icon.contact-icon {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.section-icon.marital-icon {
  background: linear-gradient(135deg, #ff6b6b 0%, #ffa07a 100%);
}

.section-icon.security-icon {
  background: linear-gradient(135deg, #4e54c8 0%, #8f94fb 100%);
}

.section-header-text h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
}

.section-header-text p {
  font-size: 0.8125rem;
  color: #6b7280;
  margin: 0;
}

/* ==================== FORM FIELDS ==================== */
.section-content {
  padding-top: 0.25rem;
}

.form-field {
  margin-bottom: 1.25rem;
}

.field-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.field-label svg {
  color: #6b7280;
}

.custom-input {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.625rem 0.875rem;
  font-size: 0.9rem;
  color: #1f2937;
  background-color: #ffffff;
  transition: all 0.2s ease;
}

.custom-input:focus {
  border-color: var(--color-btn, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  outline: none;
}

.custom-input.readonly-field {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: default;
}

.custom-input::placeholder {
  color: #9ca3af;
}

.custom-select,
.custom-datepicker {
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
}

/* ==================== SECURITY SECTION ==================== */
.security-notice {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 0.875rem 1rem;
  border-radius: 8px;
  margin-bottom: 1.25rem;
}

.notice-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #ffffff;
  border-radius: 8px;
  color: var(--color-btn, #3b82f6);
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
}

.security-notice p {
  font-size: 0.8125rem;
  color: #4b5563;
  margin: 0;
  line-height: 1.5;
}

/* ==================== PROFILE ACTIONS ==================== */
.profile-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.btn-save-profile {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--color-btn, linear-gradient(90deg, #3b82f6, #2563eb));
  color: var(--color-btn-text, #ffffff);
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-save-profile:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.btn-save-profile:active {
  transform: translateY(0);
}

/* ==================== RESPONSIVE STYLES ==================== */
@media (max-width: 768px) {
  .profile-header {
    padding: 1.5rem;
  }

  .profile-header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .profile-avatar {
    width: 60px;
    height: 60px;
  }

  .avatar-initials {
    font-size: 1.25rem;
  }

  .profile-name {
    font-size: 1.25rem;
  }

  .profile-stats {
    width: 100%;
  }

  .profile-stat-item {
    flex: 1;
    justify-content: center;
  }

  .profile-section {
    padding: 1.25rem;
  }

  .section-icon {
    width: 40px;
    height: 40px;
  }

  .section-header-text h3 {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .profile-header {
    padding: 1.25rem;
    margin-bottom: 16px;
  }

  .profile-avatar-section {
    gap: 1rem;
  }

  .profile-avatar {
    width: 52px;
    height: 52px;
    border-width: 2px;
  }

  .avatar-initials {
    font-size: 1.1rem;
  }

  .profile-name {
    font-size: 1.1rem;
  }

  .profile-id {
    font-size: 0.8rem;
  }

  .profile-id svg {
    width: 14px;
    height: 14px;
  }

  .profile-stat-item {
    gap: 0.375rem;
  }

  .stat-icon {
    width: 24px;
    height: 24px;
  }

  .stat-icon svg {
    width: 16px;
    height: 16px;
  }

  .stat-label {
    font-size: 0.75rem;
  }

  .profile-section {
    padding: 1rem;
    margin-bottom: 16px;
  }

  .section-header-card {
    gap: 0.75rem;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
  }

  .section-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
  }

  .section-icon svg {
    width: 18px;
    height: 18px;
  }

  .section-header-text h3 {
    font-size: 0.95rem;
  }

  .section-header-text p {
    font-size: 0.75rem;
  }

  .form-field {
    margin-bottom: 1rem;
  }

  .field-label {
    font-size: 0.75rem;
    gap: 0.375rem;
  }

  .field-label svg {
    width: 14px;
    height: 14px;
  }

  .custom-input {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
    border-radius: 6px;
  }

  .security-notice {
    padding: 0.75rem;
    border-radius: 6px;
    gap: 0.5rem;
  }

  .notice-icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
  }

  .notice-icon svg {
    width: 16px;
    height: 16px;
  }

  .security-notice p {
    font-size: 0.75rem;
  }

  .profile-actions {
    margin-top: 0.25rem;
  }

  .btn-save-profile {
    width: 100%;
    justify-content: center;
    padding: 0.75rem 1.25rem;
    font-size: 0.85rem;
  }
}

/* ==================== BOOTSTRAP OVERRIDES ==================== */
.profile-section :deep(.form-control) {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.625rem 0.875rem;
  font-size: 0.9rem;
  height: auto;
}

.profile-section :deep(.form-control:focus) {
  border-color: var(--color-btn, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.profile-section :deep(.custom-select) {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.625rem 0.875rem;
  font-size: 0.9rem;
  height: auto;
  background-position: right 0.875rem center;
}

.profile-section :deep(.b-form-datepicker) {
  border-radius: 8px;
}

.profile-section :deep(.b-form-datepicker .form-control) {
  border-radius: 8px;
}

.profile-section :deep(.invalid-feedback) {
  font-size: 0.75rem;
  margin-top: 0.375rem;
}

.profile-section :deep(.is-invalid) {
  border-color: #ef4444 !important;
}

.profile-section :deep(.is-valid) {
  border-color: #10b981 !important;
}
</style>
